import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PropsWithChildren } from "react";
import { toast } from "react-toastify";
import { rollbarInstance } from "../config/rollbar";

// Initialization of the react-query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
      refetchOnWindowFocus: false, // Disables sending a new request everytime the window is refocused
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      const queryMetaExtraDetails = query.meta?.extra_details ?? {};
      const errorMessage = error.message || "Something went wrong!";

      toast.error(errorMessage);

      // Note: These GET requests are set to warning level
      // to avoid unnecessary spam as they are mostly related to
      // "errors" such as not found resource, unauthenticated etc.
      rollbarInstance.warn(errorMessage, error, queryMetaExtraDetails);
    },
  }),
});

const QueryClientContext: React.FC<PropsWithChildren> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export default QueryClientContext;
